

//Web version Tab1.jsx

import { useContext } from "react";
import { TeamsFxContext } from "../teams/Context.jsx";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";
// import SettingReact from "./Demo/Setting/SettingReact";
// import NewBooking from "./Demo/Booking/NewBooking";
// import Colleagues from "./Demo/Colleagues/Colleagues";

import LegacyCalendar from "../modules/LegacyCalendar/CalendarTest/Calendar.jsx";
import CalendarEvent from "../modules/Calendar/Calendar/CalendarEvent.jsx";

import Login from "../modules/Login/LoginEvent.jsx"
import MapDefault from "../modules/Map/MapDefault.jsx";
import MyBooking from "../modules/MyBooking/MyBookingUI.jsx";
import Colleagues from "../modules/Colleagues/Colleagues.jsx";
import Emp1 from "../modules/EmployeeRoles/EmpDesign.jsx"
import SettingReact from "../modules/Setting/SettingReact.jsx";
import NewBooking from "../modules/NewBooking/NewBookingUI.jsx";

import Logout from "../modules/Login/Logout.jsx";

import WeekCalendar from "../modules/WeeklyCalendar/WeeklyCalendarEvent.jsx";

// import "../assets/css/bootstrap.min.css";
// import "../assets/css/all.min.css";
// import "../assets/css/common.css";
// import "../assets/css/jquery.mCustomScrollbar.css";
// import "../assets/css/language-dropdown.css";
// import "../assets/css/style.css";
// import "../assets/css/responsive.css";

//import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import AutoLogin from "../modules/AutoLogin/AutoLogin.jsx";
import RegisterSuccess from "../modules/Login/RegisterSuccess.jsx";
import ConformationRegister from "../modules/Login/ConformationRegister.jsx";
import ResetPassword from "../modules/Login/ResetPassword.jsx";
import InactiveUserResponseHandler from "../modules/Common/InactiveUserResponseHandler.jsx";

export default function Tab() {

  //   useEffect(() => {
  //   startEventLogger();     // Start event tracking

  //   return () => {
  //     stopEventLogger();    // Cleanup event tracking
  //   };
  // }, []);

  useContext(TeamsFxContext);
  return (
    <Router>
      <InactiveUserResponseHandler />
  
      {/* Logging Control Buttons (optional UI) */}
      {/* <div style={{ padding: "10px", background: "#f5f5f5" }}>
        <button onClick={() => setLogging(1)}>Enable Logging</button>
        <button onClick={() => setLogging(0)}>Disable Logging</button>
        <button onClick={downloadLogs}>Download Log File</button>
      </div> */}


      {/* <IFrame/> */}
      <Switch>
        {/* Enable this before Staging update */}

        <Route exact path="/registersuccess" component={RegisterSuccess} />
        <Route exact path="/verifyuser/:uniqueCode?" component={ConformationRegister} />
        <Route exact path="/resetpassword/:uniqueId?" component={ResetPassword} />
        <Route exact path="/autologin" component={AutoLogin} />
        
        <Route exact path="/" component={Login} />
        <Route exact path="/login" component={Login} />

        <Route path="/calendars" component={LegacyCalendar} /> {/* Legacy calendar */}

        <Route path="/calendar" component={CalendarEvent} />

        {/* <Route path="/weekCalendar" component={WeekCalendar} /> */}

        {/* <Route path="/weekCalendar" component={WeekCalendar} /> */}
        {/* Protected Routes */}
        <Route exact path="/weekCalendar">
          {/* <ProtectedRoute> */}
            <WeekCalendar />
          {/* </ProtectedRoute> */}
        </Route>
        <Route exact path="/newbooking">
          {/* <ProtectedRoute> */}
            <NewBooking />
          {/* </ProtectedRoute> */}
        </Route>
        {/* <Route path="/calendars" component={Calendar} /> */}

        {/* <Route path="/weeklycalendar" component={TestCalendarTesting} /> */}

        {/* <Route path="/mapcanvas" component={MapCanvasZone} /> */}
        <Route path="/map" component={MapDefault} />
        {/* <Route path="/newbooking" component={MapDefault} /> */}
        {/* <Route path="/mapcanvas" component={MapGridZone} /> */}


        <Route path="/booking" component={MyBooking} />
        <Route path="/colleagues" component={Colleagues} />

        {/* <Route path="/roles" component={Emp} /> */}
        <Route path="/roles" component={Emp1} />
        {/* <Route path="/roles" component={EmployeeRoles} /> */}

          <Route path="/profile" component={SettingReact} />
          <Route path="/logout" component={Logout} />

        <Redirect from="/" to="/" />
        {/* <Redirect from="/" to="/" /> */}
      </Switch>
    </Router>
  );
}
